import React from 'react';
import { useTranslation } from '@shared/core';
import { Box, Flex, SpacingStack, TextV2 } from '@withjoy/joykit';
import { styles } from './ShippingPolicy.styles';
import { Page } from '../../components/LayoutStructure';
import { wrapWithShippingPolicyHealthProvider } from '@apps/registry/common/components/Catalog/routes/ShippingPolicy/ShippingPolicy.health';
import { Trans } from 'react-i18next';
import { Seo } from '@shared/components/Seo';

export const ShippingPolicy = wrapWithShippingPolicyHealthProvider(() => {
  const { t } = useTranslation('companyPolicies');
  const { seo, hero, paragraphs } = t('shippingPolicy');

  return (
    <Page>
      <Seo title={seo.title()} description={seo.description()} />
      <Flex __css={styles.policyContainer}>
        <TextV2 __css={styles.title} typographyVariant="HedHero72">
          {hero.title()}
        </TextV2>
        <Box __css={styles.date} typographyVariant="hed4" fontWeight="regular">
          {hero.date()}
        </Box>
        <SpacingStack spacing={6} __css={styles.paragraphs}>
          <TextV2 typographyVariant="body3" fontWeight="semibold">
            {hero.subtitle()}
          </TextV2>
          {paragraphs.map((paragraph, index) => (
            <TextV2 key={index} typographyVariant="body3">
              <Trans i18nKey={`shipping-handling-valueprop-${index}`}>{paragraph.text()}</Trans>
            </TextV2>
          ))}
        </SpacingStack>
      </Flex>
    </Page>
  );
});
